import React, { useEffect, useState } from 'react'

import { Form, Input, InputNumber, Upload, Button, Row, Col, message, Modal, notification, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createVehicle } from '../../../api/vehicles.service';
import { getVehiclesTypes } from '../../../api/vehicles-type.service';

export default function AddVehicleFormModal({fetchVehiclesTypes,  isModalOpen, setIsModalOpen, handleOk, handleCancel }) {

    const [options, setOptions] = useState([]);

    const onFinish = async (values) => {
        try {
            await createVehicle(values);
            notification.success({ message: "Vehicle added" });
            fetchVehiclesTypes();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const fetchVehicles = async () => {
        try {
            const data = await getVehiclesTypes();
            setOptions(data?.data?.map((elem) => {
                return {
                    value: elem.id,
                    label: elem.name
                }
            }) || []); // Set the fetched vehicles data
        } catch (err) {
            notification.error({ message: 'Failed to fetch vehicles types' });
        } finally {
        }
    };

    useEffect(() => {
        fetchVehicles();
    }, []);

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add Vehicle" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{
                    registrationNo: "",
                    vehicleType: "",
                    make: "",
                    model: "",
                    color: "",
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Vehicle reg no" name="registrationNo" rules={[{ required: true, message: "Please enter vehicle registration number" }]}>
                                <Input placeholder='Enter registration number'/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Make" name="make" rules={[{ required: true, message: "Please enter vehicle make" }]}>
                                <Input placeholder='Enter vehicle make'/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Model" name="model" rules={[{ required: true, message: "Please enter vehicle model" }]}>
                                <Input placeholder='Enter vehicle model'/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Color" name="color" rules={[{ required: true, message: "Please enter vehicle color" }]}>
                                <Input placeholder='Enter vehicle color'/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Vehicle Type" name="vehicleType" rules={[{ required: true, message: "Please select vehicle type" }]}>
                                <Select
                                    className='vt-sel'
                                    placeholder="Select vehicle type"
                                    style={{ height: '37px !important', borderRadius: '8px !important' }}
                                    options={options}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};